import isDiscountCodeVisible from './isDiscountCodeVisible';

/**
 * Whether the referral coupon may be applied on the step the buyer is standing on.
 *
 * Aliased to the input's own visibility rule rather than restated, because the two answer the same
 * question: a referral code is only applied where the buyer could have typed that same code by
 * hand. Keeping a second copy of the predicate is what let the automatic decision and the rendered
 * field drift apart — the coupon applying on a surface with no input, or skipped on one that shows
 * it. The alias makes that drift unrepresentable.
 *
 * @type {typeof isDiscountCodeVisible}
 */
export const isCheckoutDiscountCodeAvailable = isDiscountCodeVisible;

/** Before creation, pricing is unknown; only a full-page checkout can receive a deferred code. */
export function shouldDeferReferralCoupon({ features = {}, purchaseSurface, isExchange = false }) {
  return Boolean(purchaseSurface === 'fullPage' && features.DISCOUNT_CODE_ENABLED && !isExchange);
}
